import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-service-drone',
  templateUrl: './service-drone.component.html',
  styleUrls: ['./service-drone.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceDroneComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {}
  toOrdering() {
    this.router.navigate(['/']);
  }
}
